'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates an inspector button
 *
 * @class
 */

class InspectorButton extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'title': '',
				'icon' : '',
                'tooltip': ''
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<% if (icon !== '' && title !== '') { %>
				<div class="editor__inspector__item__tool">
					<a class="js-inspector_button">
						<div class='editor__inspector__item__tool__svg'><%= embedded_svg(icon) %></div>
						<div class='editor__inspector__item__button editor__inspector__item__button--normal btn btn--m' title='<%- tooltip %>'><%- title %></div>
					</a>
				</div>
			<% } else if(icon !== '') { %>
				<div class="editor__inspector__item__tool">
					<a class='js-inspector_button' title='<%- tooltip %>'>
                        <div class='editor__inspector__item__tool__svg'>
                            <%= embedded_svg(icon) %>
                        </div>
                    </a>
				</div>
			<% } else { %>
				<div class="editor__inspector__item">
    				<a class='editor__inspector__item__button editor__inspector__item__button--normal btn btn--m js-inspector_button' title='<%- tooltip %>'>
    					<%- title %>
    				</a>
				</div>
			<% } %>
		`;

		super.render();

		/**
		* Click event
		*
		* @fires Inspector#_clicked
		*/
		$('.js-inspector_button', this.$el).on('click', this._clicked);
	}

	/**
	* setValue
	*
	* @param {string} value - the value that you want to set
	*/

	setValue(value){
		$('.js-inspector_button', this.$el).html(value);
	}

	/**
     * @event Inspector#Cioui:Inspector:click
     * @property {String}Cioui:Inspector:click
     * @returns {Object} event - native click Event
     */

	_clicked(e){
		e.preventDefault();
		$(e.currentTarget).trigger('Cioui:Inspector:click', e);
	}

	/*
     * Make a tool disabled
     */
	disable(){
        this.$el.addClass('editor__inspector__item__tool--disabled');
    }

    /*
     * Enable a tool after it has been disabled
     */
    enable(){
        this.$el.removeClass('editor__inspector__item__tool--disabled');
    }

    /*
     * Make button active
     */
    setActive(){
        $('.editor__inspector__item__button', this.$el).removeClass('editor__inspector__item__button--normal').addClass('editor__inspector__item__button--active');
    }

    /*
     * Make button inactive
     */
    setInActive(){
        $('.editor__inspector__item__button', this.$el).removeClass('editor__inspector__item__button--active').addClass('editor__inspector__item__button--normal');
    }
}

module.exports = InspectorButton;
